<template>
  <div ref="autocompleteContainer"></div>
</template>
  
  <script lang="jsx">
  import { h as createElement, Fragment, render } from 'vue';

  import { createWidgetMixin } from 'vue-instantsearch/vue3/es';
  import { connectSearchBox } from 'instantsearch.js/es/connectors';
  import { autocomplete } from '@algolia/autocomplete-js';

  import { INSTANT_SEARCH_INDEX_NAME } from './search_utils/constants';
  // import { searchClient } from './search_utils/searchClient';

  import { connectInfiniteHits } from 'instantsearch.js/es/connectors';
  function debounce(fn, time) {
    let timerId;

    return function(...args) {
      if (timerId) {
        clearTimeout(timerId);
      }

      timerId = setTimeout(() => fn(...args), time);
    };
  }

  export default {
    mixins: [createWidgetMixin({ connector: connectSearchBox,connectInfiniteHits })],
    mounted() {
      const { instantSearchInstance } = this;

      // Debouncing delay is being defined here
      const debouncedSearch = debounce(this.executeSearch, 1500);

      // const debouncedSetInstantSearchUiState = debounce(setInstantSearchUiState, 2000);
//

      // Set the InstantSearch index UI state from external events
      function setInstantSearchUiState({ query }) {
        instantSearchInstance.setUiState((uiState) => ({
          ...uiState,
          [INSTANT_SEARCH_INDEX_NAME]: {
            ...uiState[INSTANT_SEARCH_INDEX_NAME],
            // We reset the page when the search state changes
            page: 1,
            query,
          },
        }));
      }

  
    let initialState;
    const helper = instantSearchInstance.mainIndex.getHelper();
    if (helper) {
      initialState = helper.state;
    } else {
      initialState = {};
    }
      this.autocompleteInstance = autocomplete({
        container: this.$refs.autocompleteContainer,
        placeholder: 'Search shops ...',
        detachedMediaQuery: 'none',
        initialState: { query: initialState.query || '' },

        openOnFocus: true,
        // Add the recent searches plugin
        plugins: [],
        onSubmit({ state }) {
          setInstantSearchUiState({ query: state.query });
        },
        onReset() {
          setInstantSearchUiState({ query: '' });
        },
        onStateChange({ prevState, state }) {
          if (prevState.query !== state.query) {
           // setInstantSearchUiState({ query: state.query });
            debouncedSearch(state.query);
            // debouncedSetInstantSearchUiState({ query: state.query });
          }
        },
        // Use Vue implementation of createElement and Fragment
        // instead of those provided with Autocomplete
        renderer: { createElement, Fragment, render },
      });
    },
    beforeUnmount() {
       this.autocompleteInstance.destroy();
      // if (this.autocompleteInstance !== undefined && this.autocompleteInstance !== null) {
      //   this.autocompleteInstance.destroy();
      // }
    },
    methods: {
    visibilityChanged(isVisible) {
      console.log("change of ...")
        if (isVisible && !this.state.isLastPage) {
        this.state.showMore();
      }
    },
    executeSearch(query) {
        const { instantSearchInstance } = this;
        
        instantSearchInstance.setUiState((uiState) => ({
            ...uiState,
            [INSTANT_SEARCH_INDEX_NAME]: {
                ...uiState[INSTANT_SEARCH_INDEX_NAME],
                page: 1,
                query,
            },
        }));
    },
  }
  };
</script>

<style scoped>
</style>